var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2451 7.99999C19.036 9.13382 19.4998 10.5127 19.4998 12C19.4998 13.4872 19.036 14.8662 18.2451 16M12.1343 4.36567L8.96863 7.53136C8.79568 7.70431 8.7092 7.79079 8.60828 7.85263C8.51881 7.90746 8.42127 7.94786 8.31923 7.97236C8.20414 7.99999 8.08185 7.99999 7.83726 7.99999H6.1C5.53995 7.99999 5.25992 7.99999 5.04601 8.10898C4.85785 8.20485 4.70487 8.35784 4.60899 8.546C4.5 8.75991 4.5 9.03994 4.5 9.59999V14.4C4.5 14.96 4.5 15.2401 4.60899 15.454C4.70487 15.6421 4.85785 15.7951 5.04601 15.891C5.25992 16 5.53995 16 6.1 16H7.83726C8.08185 16 8.20414 16 8.31923 16.0276C8.42127 16.0521 8.51881 16.0925 8.60828 16.1473C8.7092 16.2092 8.79568 16.2957 8.96863 16.4686L12.1343 19.6343C12.5627 20.0627 12.7769 20.2769 12.9608 20.2913C13.1203 20.3039 13.2763 20.2393 13.3802 20.1176C13.5 19.9773 13.5 19.6744 13.5 19.0686V4.93136C13.5 4.32554 13.5 4.02264 13.3802 3.88237C13.2763 3.76067 13.1203 3.69608 12.9608 3.70864C12.7769 3.72311 12.5627 3.9373 12.1343 4.36567Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMin);
export default __webpack_public_path__ + "static/media/volume-min.2291581232c9824e3ca7bb43044172e6.svg";
export { ForwardRef as ReactComponent };